<script>
import { loadStripe } from '@stripe/stripe-js';

export default {
  props: ['item', 'packages', 'services'],
  data() {
    return {
      dsbl_btn: false,
      
      stripe: {},
      // cardElement: {},
      cardNumber: {},
      cardExpiry: {},
      cardCvc: {},

      loading: false,

      cart: {
        listing_id: this.item.id,
        to_name: '',
        to_address: '',
        to_city: '',
        to_state: '',
        to_zip_code: '',
        package: {},
        services: [],
        estimated_total: 0.00,
        payment_method_id: '',
        agree_terms: false,
        agree_cancellation: false,
        not_refundable: false,
      }
    }
  },
  computed: {
    computedPackages: function() {
      var found = false;
      return JSON.parse(JSON.stringify(this.packages)).filter(b => {
        // Hide active_package and any packages less than it
        if(this.item.active_package && this.item.active_package.id){
          if(b.id == this.item.active_package.id) { found = true; return false; }
          return found;
        }
        return true;
      }).map(b => {
        // Subtract packages_total from package prices
        if(this.item.packages_total && parseFloat(this.item.packages_total) > 0) {
          b.price = (!(parseFloat(b.price) - parseFloat(this.item.packages_total) > 0) ? 0 : parseFloat(b.price) - parseFloat(this.item.packages_total));
        }
        // Adjust package price if upcharge by zip code
        for(var i in b.upcharges) {
          if(this.item.PostalCode && b.upcharges[i].zip_code == this.item.PostalCode && b.upcharges[i].active == "1"){ b.price = parseFloat(b.price) + parseFloat(b.upcharges[i].upcharge); break; }
        }
        return b
      });
    },
    used_services: function() {
      // Used to hide package services alreading included on previous packages
      var results = [], used = [];
      if(this.computedPackages) { for(var i in this.computedPackages) {
        var services = [];
        if(this.computedPackages[i].services) { for(var j in this.computedPackages[i].services) {
          if(used.includes(this.computedPackages[i].services[j].id)) {
            services.push(this.computedPackages[i].services[j].id);
          } else {
            used.push(this.computedPackages[i].services[j].id);
          }
        } }
        results.push(services);
      } }
      return results;
    },
    additionalServices: function () {
      return JSON.parse(JSON.stringify(this.services)).filter(b => {
        // Check if additional service
        if(!b.additional) { return false; }

        // Check if upgrade service
        if(!b.upgrade) { return false; }

        // Check if purchased before and is a once service.
        if(b.once) {
          if(this.cart.package.services) { for(var i in this.cart.package.services) {
            if(this.cart.package.services[i].id == b.id) { return false; }
          } }
          if(this.item.active_package.services) { for(var i in this.item.active_package.services) {
            if(this.item.active_package.services[i].id == b.id) { return false; }
          } }
          if(this.item.active_services) { for(var i in this.item.active_services) {
            if(this.item.active_services[i].id == b.id) { return false; }
          } }
        }

        return true;
      }).map(b => {
        b.active = false;
        for(var i in b.upcharges) {
          if(this.item.PostalCode && b.upcharges[i].zip_code == this.item.PostalCode && b.upcharges[i].active == "1"){ b.price = parseFloat(b.price) + parseFloat(b.upcharges[i].upcharge); break; }
        }
        return b
      });
    },
    estimatedTotal: function() {
      var total = 0;
      if(this.cart && this.cart.package && this.cart.package.price > 0) {
        total = total + parseFloat(this.cart.package.price);
      }
      if(this.cart.services.length > 0) { for(var i in this.cart.services) {
        if(parseFloat(this.cart.services[i].price) > 0) {
          var service_price = (this.cart.services[i].quantity ? parseFloat(this.cart.services[i].price)*parseInt(this.cart.services[i].quantity) : parseFloat(this.cart.services[i].price));
          total = total + service_price;
        }
      } }
      this.cart.estimated_total = total;
      return total;
    },
  },
  async mounted() {
    this.stripe = await loadStripe(process.env.MIX_STRIPE_KEY);
    const elements = this.stripe.elements();

    // this.cardElement = elements.create('card');
    // this.cardElement.mount('#card-element');

    this.cardNumber = elements.create('cardNumber');
    this.cardNumber.mount('#card-number');

    this.cardExpiry = elements.create('cardExpiry');
    this.cardExpiry.mount('#card-expiry');

    this.cardCvc = elements.create('cardCvc');
    this.cardCvc.mount('#card-cvc');


  },
  created() {
    if(this.user.BillingAddress) { this.cart.to_address = this.user.BillingAddress; }
    if(this.user.BillingCity) { this.cart.to_city = this.user.BillingCity; }
    if(this.user.BillingStateOrProvince) { this.cart.to_state = this.user.BillingStateOrProvince; }
    if(this.user.BillingPostalCode) { this.cart.to_zip_code = this.user.BillingPostalCode; }
  },
  methods: {
    toggle_packages(pack) {
      this.cart.services = [];
      if(this.cart.package.id == pack.id) {
        this.cart.package = {};
      } else {
        var new_package = {
          id: pack.id,
          title: pack.title,
          services: [],
          price: parseFloat(pack.price),
          quantity: 1,
        };
        for(var i in pack.services) {
          new_package.services.push({
            id : pack.services[i].id,
            title : pack.services[i].title,
            description : pack.services[i].description,
          });
        }
        this.cart.package = new_package;
      }
    },
    toggle_service(service) {
      var found = false;
      for(var i in this.cart.services) {
        if(this.cart.services[i].id == service.id) {
          this.cart.services.splice(i, 1);
          found = true;
        }
      }
      if(!found) {
        var new_service = {
          id: service.id,
          title: service.title,
          description: service.description,
          price: parseFloat(service.price),
          quantity: 1,
          once: service.once,
        };
        this.cart.services.push(new_service);
      }
    },
    quantity_change(serv, serv_i) {
      this.cart.services[serv_i].quantity = Math.round(this.cart.services[serv_i].quantity);
      if(serv.quantity < 1) {
        if(this.dsbl_btn == true) { this.$noty.warning('Disabled'); return; } this.dsbl_btn = true;
        var randomid = 'id'+(Math.random() + 1).toString(36).substring(7);
        var removed = false;
        var n = new Noty({
          timeout: false,
          modal: true,
          type: 'alert', // alert, success, warning, error, info
          layout: 'center', // top, topLeft, topCenter, topRight, center, centerLeft, centerRight, bottom, bottomLeft, bottomCenter, bottomRight
          closeWith: ['button'], // click, button
          text: "Remove this item from the cart?",
          buttons: [
            Noty.button('<span id="'+randomid+'_spin" class="d-none spinner-border spinner-border-sm"></span> YES', 'btn btn-danger px-4 float-right ml-2', notyres => {
              var btn = document.getElementById(randomid), spin = document.getElementById(randomid+"_spin"), btnno = document.getElementById(randomid+"_no");
              if(btn.disabled) { this.$noty.warning('Disabled'); return; } btn.disabled = btnno.disabled = true; spin.classList.remove("d-none");
              this.cart.services.splice(serv_i, 1);
              removed = true;
              this.dsbl_btn = btn.disabled = btnno.disabled = false; spin.classList.add("d-none");
              n.close();
            }, {id: randomid, 'data-status': 'ok'}),
            Noty.button('NO', 'btn btn-light px-4 mr-2', notyres => {
              this.cart.services[serv_i].quantity = 1;
              n.close();
            }, {id: randomid+'_no', 'data-status': 'ok'}),
          ]
        }).show().on('onClose', () => { if(!removed) { this.cart.services[serv_i].quantity = 1; } this.dsbl_btn = false; });
      }
      if(serv.quantity > 99) { this.cart.services[serv_i].quantity = 99; }
    },
    async submit_form() {
      if(this.loading == true) { console.log("disabled"); return; } this.loading = true;

      // =======================
      if(
        Object.keys(this.cart.package).length === 0 &&
        this.cart.services.length == 0
      ) {
        this.$noty.error("A package upgrade or A La Carte service is required before checking out.");
        this.loading = false; return;
      }

      // =======================
      if(
        !this.cart.agree_terms ||
        !this.cart.not_refundable
      ) {
        this.$noty.error("Before continuing you must agree to our listing agreements.");
        this.loading = false; return;
      }

      if(this.cart.estimated_total > 0) {
        const {paymentMethod, error} = await this.stripe.createPaymentMethod('card', this.cardNumber, {
          billing_details: {
            name: this.cart.to_name,
            email: this.user.email,
            phone: this.user.phone,
            address: {
              line1: this.cart.to_address,
              city: this.cart.to_city,
              state: this.cart.to_state,
              postal_code: this.cart.to_zip_code
            }
          }
        });
        if(error) {
          console.log(error);
          if(error.message) { this.$noty.error(error.message); }
          else { this.$noty.error(error); }
          this.loading = false;
          return;
        }
        this.cart.payment_method_id = paymentMethod.id;
      }
      this.$http.post('/listings/upgrade', this.cart).then(res => {
        // console.log(res);
        this.item.StandardStatus = res.data.StandardStatus;
        this.item.packages_total = res.data.packages_total;
        this.item.estimated_total = res.data.estimated_total;
        this.item.active_package = res.data.active_package;
        this.item.active_services = res.data.active_services;
        this.item.user = res.data.user;
        this.item.carts = res.data.carts;
        this.$noty.success("Listing upgrade complete");
        this.$emit('setpage', 'history');
        this.loading = false;
      }).catch(res => { console.log(res); this.popupErrors(res); this.loading = false; });
    },
  }
}
</script>

<template>

  <div class="_w-m-1400 mx-auto my-5">
    <form @submit.prevent="submit_form()">
      <div class="text-center mb-5 _w-m-1000 mx-auto">
        <img :src="formatImage('/fm/revinre-nc/clip art/Packages and Services.jpg')" class="_w-m-400" data-aos="fade-zoom-in">
        <h3 class="mb-3" data-aos="fade-zoom-in">Purchase upgrades</h3>
        <p class="text-muted" data-aos="fade-zoom-in">Below you can purchase package upgrades as well as A La Carte services. Any amount previously spent on packages will be discounted from package upgrades.</p>
      </div>

      <div class="row m-0 justify-content-center mb-5">
        <div v-for="(pack, pack_i) in computedPackages" :key="pack_i" class="col _w-n-255 _w-m-400 p-2" data-aos="fade-zoom-in">
          <div class="card grow text-center p-4 pb-5 h-100 position-relative _c-pointer" @click="toggle_packages(pack)">
            <div v-if="pack.ribbon_text && pack.ribbon_color" class="ribbon-two ribbon-lg " :class="'ribbon-two-'+pack.ribbon_color"><span>{{pack.ribbon_text}}</span></div>
            <h3 class="h2 m-0">{{pack.title}}</h3>
            <p class="mb-4">{{pack.sub_title}}</p>
            <p class="h3 m-0">{{formatPrice(pack.price, true, false)}}</p>
            <p class="mb-5">{{pack.sub_price}}</p>
            <ul class="list-unstyled text-left font-weight-600">
              <li v-if="pack_i > 0" class="border-bottom border-fade-d-01 mb-2 pb-2 font-weight-bold" :content="'* Includes '+packages[pack_i-1].title+' services'" v-tippy>
                * Includes {{packages[pack_i-1].title}} services
              </li>
              <li v-for="(serv, serv_i) in pack.services" :key="serv_i" v-if="!used_services[pack_i].includes(serv.id)" class="border-bottom border-fade-d-01 mb-2 pb-2" v-tippy :content="serv.description" @show="() => serv.description ? true : false">
                {{serv.title}} <Icon v-if="serv.description" icon="ri:information-fill" class="text-gray-400"></Icon>
              </li>
            </ul>
            <div class="text-center position-absolute _pos-b-0 _pos-l-0 _pos-r-0 p-3">
              <button v-if="cart.package.id == pack.id" type="button" class="btn btn-success px-5">Selected</button>
              <button v-else type="button" class="btn btn-light px-5">Select</button>
            </div>
          </div>
        </div>
      </div>

      <div class="text-center py-5">
        <Icon icon="ri:hand-heart-line" height="45" class="text-revinre mb-2" />
        <h3 class="mb-3" data-aos="fade-zoom-in">A La Carte services</h3>
        <p class="text-muted" data-aos="fade-zoom-in" data-aos-delay="200">One of the best parts of the {{ app_name }} system is the ability to pick and choose only the services you truly need.</p>
      </div>
      <div class="row m-0 mb-5">
        <div v-for="(serv, serv_i) in additionalServices" :key="serv_i" class="col-sm-6 col-md-4 p-1" data-aos="fade-zoom-in" v-tippy :content="serv.description" @show="() => serv.description ? true : false">
          <div class="p-sm-2 h-100 grow rounded _c-pointer" @click="toggle_service(serv)" :class="cart.services.filter(b => { if(b.id == serv.id) { return true; } else { return false; } }).length ? 'bg-success text-white' : 'bg-gray-100'">
            <p class="m-0 p-1 font-weight-bold">
              <Icon v-if="cart.services.filter(b => { if(b.id == serv.id) { return true; } else { return false; } }).length" icon="ri:checkbox-line" height="25" class="mr-2" />
              <Icon v-else icon="ri:checkbox-blank-line" height="25" class="mr-2" />
              {{serv.title}} <Icon v-if="serv.description" icon="ri:information-fill" class="text-muted" /> <span :class="cart.services.filter(b => { if(b.id == serv.id) { return true; } else { return false; } }).length ? 'text-white' : 'text-muted'">({{formatPrice(serv.price, true, false)}})</span></p>
          </div>
        </div>
      </div>

      <div class="text-center py-5">
        <Icon icon="ri:shopping-cart-2-line" height="45" class="text-revinre mb-2" />
        <h3 class="mb-3" data-aos="fade-zoom-in">Shopping Cart</h3>
        <p class="text-muted" data-aos="fade-zoom-in" data-aos-delay="200">Be sure to double check everything in your shopping cart including quantities before checking out.</p>
      </div>
      <div class="_w-m-1000 mx-auto">
        <div class="border rounded p-3 mb-3">
          <h5 class="mb-3">Packages and services</h5>
          <div class="table-responsive">
            <table class="table small m-0">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Item</th>
                  <th style="width: 10%">Quantity</th>
                  <th style="width: 10%" class="text-right">Total</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="Object.keys(cart.package).length > 0">
                  <td>1</td>
                  <td>
                    <b>{{cart.package.title}} Package</b> <br>
                    <p v-for="(pack, pack_i) in cart.package.services" :key="'a'+pack_i" class="text-gray-700 m-0">{{pack.title}}</p>
                  </td>
                  <td>1</td>
                  <td class="text-right">{{formatPrice(cart.package.price)}}</td>
                </tr>
                <tr v-for="(serv, serv_i) in cart.services" :key="'b'+serv.id">
                  <td>{{serv_i+(cart.package ? 2 : 1)}}</td>
                  <td><b>{{serv.title}}</b></td>
                  <td v-if="!serv.once" class="p-1 align-middle">
                    <input type="number" class="form-control py-0 px-2 _h-30" v-model="serv.quantity" min="0" max="99" @change="quantity_change(serv, serv_i)">
                  </td>
                  <td v-else class="align-middle">{{serv.quantity}}</td>
                  <td class="text-right">{{formatPrice(serv.price * serv.quantity)}}</td>
                </tr>
                <tr>
                  <td class="text-right h5 pt-5 font-weight-bold" colspan="4">Cart total:<span class="text-success ml-2">{{formatPrice(estimatedTotal)}}</span></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div v-show="item.estimated_total > 0" class="border rounded p-3 mb-3">
          <div class="row">
            <div class="col-sm _w-m-250 border-right border-light">
              <h5 class="mb-3">Enter payment information</h5>
              <small class="text-muted">Processed securely through <a href="https://stripe.com/" target="_blank">Stripe</a>.</small>
              <img src="/images/stripe-payment-logo.png" class="_w-m-150 mt-1">
            </div>
            <div class="col-sm">
              <!-- <div id="card-element" class="form-control" style="padding-top: 0.6rem !important"></div> -->
              <div class="row">
                <div class="col-sm-12">
                  <div class="form-group">
                    <label for="field-BillingName">Name on card <span class="text-danger" v-tippy content="This field is required.">*</span></label>
                    <input id="field-BillingName" name="address" type="text" class="form-control" v-model="cart.to_name" required>
                    <small class="text-muted"></small>
                  </div>
                </div>
              </div>
              <hr>
              <div class="row">
                <div class="col-sm-12">
                  <div class="form-group">
                    <label for="field-to_address">Billing address <span class="text-danger" v-tippy content="This field is required.">*</span></label>
                    <input id="field-to_address" name="address" type="text" class="form-control" v-model="cart.to_address" required>
                    <small class="text-muted"></small>
                  </div>
                </div>
                <div class="col-sm-4">
                  <div class="form-group">
                    <label for="field-to_city">Billing city <span class="text-danger" v-tippy content="This field is required.">*</span> </label>
                    <input id="field-to_city" name="city" type="text" class="form-control" v-model="cart.to_city" required>
                    <small class="text-muted"></small>
                  </div>
                </div>
                <div class="col-sm-4">
                  <div class="form-group">
                    <label for="field-to_state">Billing state <span class="text-danger" v-tippy content="This field is required.">*</span></label>
                    <select id="field-to_state" name="state" class="form-control" v-model="cart.to_state" required>
                      <option value="AL">Alabama</option>
                      <option value="AK">Alaska</option>
                      <option value="AZ">Arizona</option>
                      <option value="AR">Arkansas</option>
                      <option value="CA">California</option>
                      <option value="CO">Colorado</option>
                      <option value="CT">Connecticut</option>
                      <option value="DE">Delaware</option>
                      <option value="DC">District Of Columbia</option>
                      <option value="FL">Florida</option>
                      <option value="GA">Georgia</option>
                      <option value="HI">Hawaii</option>
                      <option value="ID">Idaho</option>
                      <option value="IL">Illinois</option>
                      <option value="IN">Indiana</option>
                      <option value="IA">Iowa</option>
                      <option value="KS">Kansas</option>
                      <option value="KY">Kentucky</option>
                      <option value="LA">Louisiana</option>
                      <option value="ME">Maine</option>
                      <option value="MD">Maryland</option>
                      <option value="MA">Massachusetts</option>
                      <option value="MI">Michigan</option>
                      <option value="MN">Minnesota</option>
                      <option value="MS">Mississippi</option>
                      <option value="MO">Missouri</option>
                      <option value="MT">Montana</option>
                      <option value="NE">Nebraska</option>
                      <option value="NV">Nevada</option>
                      <option value="NH">New Hampshire</option>
                      <option value="NJ">New Jersey</option>
                      <option value="NM">New Mexico</option>
                      <option value="NY">New York</option>
                      <option value="NC">North Carolina</option>
                      <option value="ND">North Dakota</option>
                      <option value="OH">Ohio</option>
                      <option value="OK">Oklahoma</option>
                      <option value="OR">Oregon</option>
                      <option value="PA">Pennsylvania</option>
                      <option value="RI">Rhode Island</option>
                      <option value="SC">South Carolina</option>
                      <option value="SD">South Dakota</option>
                      <option value="TN">Tennessee</option>
                      <option value="TX">Texas</option>
                      <option value="UT">Utah</option>
                      <option value="VT">Vermont</option>
                      <option value="VA">Virginia</option>
                      <option value="WA">Washington</option>
                      <option value="WV">West Virginia</option>
                      <option value="WI">Wisconsin</option>
                      <option value="WY">Wyoming</option>
                    </select>
                    <small class="text-muted"></small>
                  </div>
                </div>
                <div class="col-sm-4">
                  <div class="form-group">
                    <label for="field-to_zip_code">Billing zip code <span class="text-danger" v-tippy content="This field is required.">*</span></label>
                    <input id="field-to_zip_code" name="zip_code" type="text" class="form-control" v-model="cart.to_zip_code" required>
                    <small class="text-muted"></small>
                  </div>
                </div>
              </div>
              <hr>
              <div class="row">
                <div class="col-sm-12 mb-3">
                  <label for="card_element" class="d-block">Card number <span class="text-danger" v-tippy content="This field is required.">*</span></label>
                  <div id="card-number" class="form-control" style="padding-top: 0.6rem !important"></div>
                </div>
                <div class="col-sm-6 mb-3">
                  <label for="card_element" class="d-block">Expiration date <span class="text-danger" v-tippy content="This field is required.">*</span></label>
                  <div id="card-expiry" class="form-control" style="padding-top: 0.6rem !important"></div>
                </div>
                <div class="col-sm-6 mb-3">
                  <label for="card_element" class="d-block">CVC code <span class="text-danger" v-tippy content="This field is required.">*</span></label>
                  <div id="card-cvc" class="form-control" style="padding-top: 0.6rem !important"></div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="border rounded p-3 mb-3">
          <h5 class="mb-3">Listing agreements</h5>
          <div class="mb-2">
            <p-check class="p-default p-curve p-smooth" color="success" v-model="cart.agree_terms" required v-tippy content="Our 'Privacy Policy', 'Terms & Conditions' and 'Refund & Cancellation Policy' can be viewed at the very bottom of any page.">I agree to {{app_name}}'s terms of service. <span class="text-danger" v-tippy content="This field is required.">*</span></p-check>
          </div>
          <div class="mb-2">
            <p-check class="p-default p-curve p-smooth" color="success" v-model="cart.not_refundable" required v-tippy content="Our 'Privacy Policy', 'Terms & Conditions' and 'Refund & Cancellation Policy' can be viewed at the very bottom of any page.">I understand that all sales are final and not refundable. <span class="text-danger" v-tippy content="This field is required.">*</span></p-check>
          </div>
          <div v-if="cart.package && cart.package.price == 0">
            <p-check class="p-default p-curve p-smooth mb-1" color="success" v-model="cart.agree_cancellation" required v-tippy content="The cancellation fee should be listed on the package details.">I understand that the {{cart.package.title}} package has a cancellation fee. <span class="text-danger" v-tippy content="This field is required.">*</span></p-check>
          </div>
        </div>

      </div>

      <div class="row py-5 _w-m-1000 mx-auto">
        <div class="col-6">
          <button type="button" class="btn btn-lg btn-success" @click="$emit('curpage')" :disabled="loading || dsbl_btn"><Icon icon="ri:arrow-left-double-fill" /> Previous</button>
        </div>
        <div class="col-6 text-right">
          <button type="submit" class="btn btn-lg btn-success" :disabled="loading || dsbl_btn"><span class="spinner-border spinner-border-sm" v-show="loading"></span> {{loading ? 'Processing...' : item.estimated_total > 0 ? 'Submit payment' : 'Submit'}} <Icon icon="ri:arrow-right-double-fill" /></button>
        </div>
      </div>
    </form>
  </div>

</template>
